import Hero from '../components/Hero'
import VideoSection from '../components/VideoSection'
import BookCallout from '../components/BookCallout'
import HighlightsSection from '../components/HighlightsSection'
import SEO from '../components/SEO'

export default function Home() {
  return (
    <main>
      <SEO 
        title="Home"
        description="Indoctri-NATION 365: A practical guide for white people ready to help dismantle systemic racism. Learn the real history you were never taught and take meaningful action toward justice."
        keywords="Indoctri-NATION 365, systemic racism, racial justice, anti-racism, American history, white privilege, social justice, Kim Synergy, racial equity, civil rights"
        url="https://indoctrination365.com"
      />
      <Hero />
      <VideoSection />
      <BookCallout />

      <HighlightsSection />
    </main>
  )
}